import React, {Component} from 'react'
import Modal from 'react-bootstrap/lib/Modal.js'

export class ModalTrigger extends Component{
    constructor(props){
        super(props)
        this.state = {
            visible: false
        }
        this.show = () => this.setState({visible: true})
        this.hide = () => this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}

export const ModalCommentClient = ({service, hideModal}) => {
    return (
        <Modal show={true} onHide={hideModal}>
            <Modal.Header closeButton>
                <Modal.Title>Comentario de cliente, motivo de rechazo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label>{`${service.store_ceco} ${service.store_name}`}</label>
                <textarea readonly
                    className="form-control"
                    value={service.client_comment}
                    
                />
                </div>       
            </Modal.Body>
        </Modal>
        
    )    
}


// WEBPACK FOOTER //
// ./frontEnd/billing/billing-services/Modales.jsx